import React from 'react'
import {MembersBaseErrorPage} from '../../Error/MembersBaseErrorPage'
import {MembersPageTemplateProps} from '../../../Molecules/BaseMembersPages/MembersPageTemplate'

export type CvsProcedureOrCompletedErrorPageProps = Pick<MembersPageTemplateProps, 'bucketInfo'> & {
  pageTitle: string
  errorSummaryHeadLine: string
  errorSummaryDetail: string

}
export const CvsProcedureOrCompletedErrorPage: React.VFC<CvsProcedureOrCompletedErrorPageProps> = (
  {
    bucketInfo,
    pageTitle,
    errorSummaryHeadLine,
    errorSummaryDetail,
  },
) => {
  return <MembersBaseErrorPage
    bucketInfo={bucketInfo}
    pageTitle={pageTitle}
    errorSummaryHeadLine={errorSummaryHeadLine}
    errorSummaryDetail={errorSummaryDetail}
    errorSummaryAreaTestId={'cvs-procedure-or-completed-error-messages'}
    buttonName={bucketInfo?.fcMyPageInfo.name}
    url={bucketInfo?.fcMyPageInfo.url}
  />
}
